"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestAnonymous = void 0;
/** Symbol representing an unauthenticated guest */
exports.GuestAnonymous = Symbol('AnonymousGuest');
